<template>
  <img
    src="/images/ecc-logo.png"
    srcset="/images/ecc-logo@2x.png 2x"
    alt="Image of the Essex County Council Logo"
  />
</template>
